// ----------------------------------------------------------------------
// <copyright file="Izenda.Body.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Body component
 */
!(function() {
  var React = require('react');
  var classnames = require('classnames');
  var EventUtils = require('EventUtils');

  var connect = require('share/enhancers/Izenda.Connect');
  var Button = require('share/components/controls/Izenda.Button');

  var Alert = require('share/components/controls/Izenda.Alert');
  var GridLayout = require('share/components/controls/Izenda.GridLayout');
  var Input = require('share/components/controls/Izenda.Input');
  var DropDown = require('share/components/controls/Izenda.DropDown');
  const { isNil } = require('lodash/fp');

  var Body = React.createClass({
    getInitialState: function() {
      return {
        isEditDesc: false,
        description: this.props.item.description
      };
    },

    componentWillReceiveProps: function(nextProps) {
      this.showEditDesc(false);
      this.updateDesc(nextProps.item.description);
    },

    showEditDesc: function(state) {
      this.setState({
        isEditDesc: state
      });
    },

    updateDesc: function(desc) {
      this.setState({
        description: desc
      });
    },

    render: function() {
      var props = this.props;
      var detail = props.item;
      var localization = this.props.localization;

      return (
        <GridLayout>
          <GridLayout.Row>
            <GridLayout.Col cols={1}>{localization.getText('COMMON_LABEL_OWNER')}: </GridLayout.Col>
            <GridLayout.Col cols={2}>
              <DropDown
                valueField="id"
                labelField="fullName"
                options={props.store.masterStore.ownerList}
                onChange={EventUtils.notifyChange(onChangeOwner.bind(this), EventUtils.DROPDOWN)}
                value={detail.ownerId}
              />
            </GridLayout.Col>
          </GridLayout.Row>
          <GridLayout.Row>
            <GridLayout.Col cols={1}>{localization.getText('COMMON_LABEL_DESCRIPTION')}: </GridLayout.Col>
            <GridLayout.Col cols={11}>{this.renderEditDescription()}</GridLayout.Col>
          </GridLayout.Row>
        </GridLayout>
      );

      function onChangeOwner(ownerId) {
        this.props.item.updateOwnerList(ownerId);
      }
    },

    renderEditDescription: function() {
      var detail = this.props.item;
      var state = this.state;
      var localization = this.props.localization;
      var editClassName = classnames('icon-pencil selectable', { hide: isNil(detail.id) });

      if (state.isEditDesc) {
        return (
          <div className="izenda-EditDesciption u_inlineBlock">
            <Input
              className="form-control u_inlineBlock"
              value={state.description}
              onChange={EventUtils.notifyChange(this.updateDesc, EventUtils.INPUT)}
            />
            <span className="">
              <a
                className="btn btn-default custom-button"
                title={localization.getText('COPY_MANAGEMENT_WORKSPACE_DETAIL_LABEL_SET_DESCRIPTION')}
                onClick={onChangeDescription.bind(this)}
              >
                <i className="icon-ok-circled" />
              </a>
              <a
                className="btn btn-default custom-button"
                title={localization.getText('COPY_MANAGEMENT_WORKSPACE_DETAIL_LABEL_REVERT_DESCRIPTION')}
                onClick={cancelEditDescription.bind(this)}
              >
                <i className="icon-cancel-circled" />
              </a>
            </span>
          </div>
        );
      } else {
        return (
          <div>
            <span>{state.description}</span>
            <i
              className={editClassName}
              title={localization.getText('COPY_MANAGEMENT_WORKSPACE_DETAIL_LABEL_RENAME')}
              onClick={showEditMode.bind(this)}
            />
          </div>
        );
      }

      function showEditMode() {
        this.showEditDesc(true);
      }

      /**
       * onRenameDescriptionClick this function is to update description in model
       */
      function onChangeDescription() {
        detail.updateWorkspaceDescription(state.description);
        this.showEditDesc(false);
      }

      function cancelEditDescription() {
        this.showEditDesc(false);
        this.updateDesc(detail.description);
      }
    }
  });

  module.exports = connect()(Body);
})();



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/CopyManagement/WorkspaceDetail/HeaderSection/Izenda.Body.jsx